import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "./styles";

type Data = {
  whatsapp?: string;
  facebook?: string;
  instagram?: string;
  tiktok?: string;
};

type FooterProps = {
  data: Data;
  bgcolor?: string;
};

const Footer = ({ data, bgcolor }: FooterProps) => {
  const styles = useStyles();
  const theme = useTheme();

  const handleNavigate = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <footer id="footer" className={styles.footer}>
      <Container maxWidth="sm">
        <Stack direction="row" spacing={2}>
          {data.whatsapp && (
            <IconButton
              size="medium"
              aria-label="whatsapp"
              onClick={() => {
                handleNavigate(
                  `https://wa.me/${data.whatsapp?.replace(/\D/g, "")}`
                );
              }}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: bgcolor,
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                },
              }}
            >
              <i
                className="fi fi-brands-whatsapp"
                // style={{ fontSize: "2.5ch" }}
              />
            </IconButton>
          )}
          {data.instagram && (
            <IconButton
              size="medium"
              disableTouchRipple
              aria-label="instagram"
              onClick={() => {
                handleNavigate(String(data.instagram));
              }}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: bgcolor,
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                },
              }}
            >
              <i
                className="fi fi-brands-instagram"
                // style={{ fontSize: "3ch" }}
              />
            </IconButton>
          )}
          {data.facebook && (
            <IconButton
              size="medium"
              disableTouchRipple
              aria-label="facebook"
              onClick={() => {
                handleNavigate(String(data.facebook));
              }}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: bgcolor,
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                },
              }}
            >
              <i
                className="fi fi-brands-facebook"
                // style={{ fontSize: "3ch" }}
              />
            </IconButton>
          )}

          {data.tiktok && (
            <IconButton
              size="medium"
              disableTouchRipple
              aria-label="tiktok"
              onClick={() => {
                handleNavigate(String(data.tiktok));
              }}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: bgcolor,
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                },
              }}
            >
              <i className="fi fi-brands-tik-tok" />
            </IconButton>
          )}
        </Stack>
      </Container>
    </footer>
  );
};

export default Footer;
